import React from 'react'
import distquicklink1 from "../../../images/dist_quick-link-1.png";
import distquicklink2 from "../../../images/dist_quick-link-2.png";
import distquicklink3 from "../../../images/dist_quick-link-3.png";
import { Container, Row, Col } from 'react-bootstrap';
import KYCIndividual from "../../../PDF/Process and Services/Individual-KYD.pdf";
import KYCNonIndividual from "../../../PDF/Process and Services/Non-Individual-KYD.pdf";
import NISMCertif from "../../../PDF/Process and Services/AMFI-Comm-NISM Certification.pdf"
import AMFIComm from "../../../PDF/Process and Services/AMFI-Communication-on-Advertisement-Code.pdf"
import codeconduct from '../../../PDF/Code of Conduct for Distributors.pdf';
import NewCadre from '../../../PDF/Process for New Cadre of Distributors.pdf';
import Reckoner from "../../../PDF/Process and Services/Final Ready Reckoner for MFDs shared with AMCs (10-Feb-25).pdf";
function KnowDistributer() {
  return (
    <>
      <div
        className="tab-pane fade show active"
        id="info"
        role="tabpanel"
        aria-label="Process and Services"
      >
        <Container>
          <Row>
            <Col sm={12}>
              <div className="distributer-h1 tab-wrapper">
                <h2>Process And Services</h2>
              </div>
              <div className="red-box-container-info">
                <div className="red-box">
                  <a href={NISMCertif} target="_blank">
                    Change in Registration Approval Process for NISM
                    Certifications
                  </a>
                </div>
                <div className="red-box">
                  <a href={AMFIComm} target="_blank">
                    AMFI Communication on Advertisement Guidelines
                  </a>
                </div>
              </div>
              <div className="red-box-container-info">
                <div className="red-box">
                  <a href={codeconduct} target="_blank">
                    Code of Conduct for Distributors
                  </a>
                </div>
                <div className="red-box">
                  <a href={NewCadre} target="_blank">
                    Process for New Cadre of Distributors
                  </a>
                </div>
                <div className="red-box">
                  <a href={Reckoner} target="_blank">
                    Ready Reckoner for Mutual Fund Distributors
                  </a>
                </div>
              </div>
              <div className="red-box-container-info"></div>
              <div className="know-your-distributer">
                <h2>Know Your Distributor - (KYD)</h2>
                <br></br>
                <p className="knowdi">
                  In order to curb financial frauds played on the investors by
                  Mutual Fund distributors/ their employees, AMFI has initiated
                  penal actions against such distributors including suspension
                  of their ARN, advising all the AMCs Board to suspend payment
                  of commission, trail commission, incentives, etc. As one of
                  the measures to control this situation, Securities and
                  Exchange Board of India (SEBI) has advised AMFI to tighten the
                  procedure for Distributor Registration. On reviewing the
                  current procedure for registration of distributors, AMFI has
                  decided to introduce a more stringent Know Your Distributor
                  (KYD) process involving obtaining relevant documents and
                  validation of such documents, personal verification and
                  bio-metrics.
                </p>
                <p className="knowdi">
                  AMFI had decided to introduce Know Your Distributor (KYD) for
                  Mutual Fund Distributors with effect from September 1, 2010,
                  which would be similar to that of Know Your Client (KYC) for
                  investors, requiring the distributors to submit mandatorily
                  identity proof, address proof, PAN and bank account details
                  with proof. It is also decided to introduce bio-metrics as a
                  part of KYD process.
                </p>
                <p className="knowdi">
                  Applicants need to submit their registration applications with
                  AMFI, along with the KYD application, at any CAMS POS
                  location. The list of locations is available on
                  www.amfiindia.com or www.camsonline.com. Distributors must
                  also present the original documents for in-person
                  verification, along with self-attested photocopies, during the
                  application submission.
                </p>
              </div>
              <div className="forms">
                <div className="particular">KYD Forms :</div>
                <div className="form-items">
                  <div className="blue-box">
                    <a href={KYCIndividual} target="_blank">
                      Individual KYD
                    </a>
                  </div>
                  <div className="blue-box">
                    <a href={KYCNonIndividual} target="_blank">
                      Non-Individual KYD
                    </a>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
}

export default KnowDistributer